export const backend_url = "https://hrexora-backend-g6qo.onrender.com/api";
// export const backend_url = "http://localhost:8000/api";